import { useGlobalForm } from '../lib/react-form';

export function useAccountVerificationForm() {
  return useGlobalForm({
    name: 'account-verification',
    values: {
      default: {
        first_name: '',
        last_name: '',
        gender: null,
        birth_date: null,
        email: '',
        otp: '',

        send_otp_confirm: false,
        verify_confirm: false,
      },
    },
  });
}
